module.exports = __webpack_public_path__ + "img/mcham.5593b59a.webp";